import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import CarCard from "../components/CarCard";
import AutoCareCta from "../components/AutoCareCta";
import AcademyCta from "../components/AcademyCta";
import { Zap, DollarSign, TrendingUp, Clock } from "lucide-react";
import { GigHubFreelance } from "../components/freelance/GigHubFreelance";

export default function GigHub() {
  const [cars, setCars] = useState([]);
  useEffect(() => { api.get("/cars", { params: { gig_ready: true } }).then(({ data }) => setCars(data)); }, []);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10" data-testid="gig-hub-page">
      <section className="relative overflow-hidden rounded-3xl mb-10 rise">
        <img src="https://images.unsplash.com/photo-1775386589409-015af9851fd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/80 to-emerald-950/40" />
        <div className="relative p-10 md:p-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 mb-5">
            <Zap className="w-3.5 h-3.5 text-emerald-400" />
            <span className="text-xs font-mono uppercase tracking-widest text-emerald-300">Gig Hub</span>
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-extrabold tracking-tight max-w-3xl">Rent to drive. Earn more than the lease.</h1>
          <p className="text-slate-300 mt-4 max-w-2xl">Every car here is rideshare- and delivery-ready. Insurance docs. Vehicle age. Clean titles. All matched to Uber, Lyft, DoorDash standards.</p>
        </div>
      </section>
      <div className="mb-10"><AutoCareCta context="for every shift" /></div>
      <GigHubFreelance />
      <div className="mb-10"><AcademyCta /></div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10 rise rise-1">
        {[
          { icon: DollarSign, label: "Avg weekly earnings", val: "$1,840" },
          { icon: Clock, label: "Avg weekly hours", val: "32h" },
          { icon: TrendingUp, label: "Driver retention", val: "92%" },
          { icon: Zap, label: "Approved vehicles", val: `${cars.length}+` },
        ].map((s) => (
          <div key={s.label} className="p-5 rounded-2xl bg-[#131722] border border-slate-800">
            <s.icon className="w-5 h-5 text-emerald-400 mb-2" />
            <p className="text-xs font-mono uppercase tracking-widest text-slate-400">{s.label}</p>
            <p className="font-display font-extrabold text-2xl mt-1">{s.val}</p>
          </div>
        ))}
      </div>

      <h2 className="font-display text-2xl font-bold mb-4">Gig-ready fleet</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {cars.map((c, i) => <CarCard key={c.car_id} car={c} delay={i * 50} />)}
      </div>
      {cars.length === 0 && <p className="text-slate-400 py-10 text-center">No gig-ready cars yet. <Link to="/list-your-car" className="text-cyan-400">List one</Link>.</p>}
    </main>
  );
}
